import api from ".";

const getEmailBodies = async () => {
  const fetchApiUrl = `${api.getApiUrl()}emailbody`;
  return api.get(fetchApiUrl, {}, {});
};

const editEmailBody = async (emailBody) => {
  const fetchApiUrl = `${api.getApiUrl()}emailbody/${emailBody.id}`;
  return api.put(fetchApiUrl, null, emailBody);
};

export default {
  getEmailBodies,
  editEmailBody,
};
